export default __webpack_public_path__ + "media/icon_3.875243bd.svg";